module.exports = __webpack_public_path__ + "static/media/18ECA41.134f858b.jpg";